import axios from 'axios';

import {catchAsync} from 'utils/catchAsync';

const normalizeNewsDetail = (payload) => {
    if (!payload || typeof payload !== 'object') {
        return null;
    }

    if (payload.item && typeof payload.item === 'object') {
        return payload.item;
    }

    if (payload.news && typeof payload.news === 'object') {
        return payload.news;
    }

    if (payload.data && typeof payload.data === 'object') {
        return normalizeNewsDetail(payload.data);
    }

    return payload;
};

export const fetchNewsDetail = (id) =>
    catchAsync(async () => {
        const { data } = await axios.get('news/getItem', {
            params: {
                id
            }
        });

        return normalizeNewsDetail(data);
    });
